const CITRIX_HDX_WEBSOCKET_SERVICE_URL = "wss://127.0.0.1:9002/";
// A closed loopback port refuses at once; only an unanswered Local Network Access prompt runs this long.
const PROBE_TIMEOUT_MS = 2000;

/**
 * Detects Citrix by its HDX WebSocket service, which doesn't prove the endpoint supports HDX
 * redirection; when it doesn't, CCP reports `VDI_REDIR_NOT_SUPPORTED` and falls back to browser WebRTC.
 */
export async function detectVdiPlatform(): Promise<"CITRIX_413" | undefined> {
    try {
        const socket = new WebSocket(CITRIX_HDX_WEBSOCKET_SERVICE_URL);
        const { promise, resolve } = Promise.withResolvers<boolean>();
        socket.addEventListener("open", () => resolve(true));
        socket.addEventListener("close", () => resolve(false));
        setTimeout(resolve, PROBE_TIMEOUT_MS, false);

        const isListening = await promise;
        socket.close();
        return isListening ? "CITRIX_413" : undefined;
    } catch {
        return undefined;
    }
}
